<form [formGroup]="consequenceAnnulationForm" (ngSubmit)="addConsequenceAnnulation()">
  <div class="form-container">
    <div>
      <label>{{'referentiels.list.consequenceAnnulationProperties.consequence.header' | transloco }}<span class="required">*</span></label>
      <input pInputText formControlName="consequence" />
      <small class="p-error block">
        @if (consequenceAnnulationForm.controls.consequence.errors?.required) {
          <p-message *ngIf="consequenceAnnulationForm.controls['consequence'].invalid && consequenceAnnulationForm.controls['consequence'].touched" severity="danger" text="Le champ pour la conséquence est requis."></p-message>
        } @else if (consequenceAnnulationForm.controls.consequence.errors?.maxlength) {
          <p-message *ngIf="consequenceAnnulationForm.controls['consequence'].invalid && consequenceAnnulationForm.controls['consequence'].touched" severity="danger" text="La conséquence ne doit pas dépasser 150 caractères."></p-message>
        }
      </small>
    </div>
  </div>

  <div class="button-container">
    <p-button [rounded]="true" pRipple label="{{ 'button.cancel' | transloco }}" (onClick)="close(false)" />
    <p-button [rounded]="true" type="submit" [disabled]="consequenceAnnulationForm.invalid" pRipple label="{{ 'button.validate' | transloco }}" />
  </div>

  <div *ngIf="submitting" class="loading-spinner">
    <p-progressSpinner [style]="{ width: '3rem', height: '3rem' }"></p-progressSpinner>
  </div>
</form>
<p-toast />
